import {Injectable} from '@angular/core';

/**
 * Translations for breadcrumbs.
 */
@Injectable()
export class BreadcrumbTranslationService {
  public i18nGlobalSettings: any = $localize`:@@general.breadcrumb.globalSettings:Global Settings`;
  public i18nClubs: any = $localize`:@@general.breadcrumb.clubs:Clubs`;
  public i18nUsers: any = $localize`:@@general.breadcrumb.users:Users`;
  public i18nProducts: any = $localize`:@@general.breadcrumb.products:Products`;
  public i18nCRM: any = $localize`:@@general.breadcrumb.crm:CRM`;
  public i18nClubSettings: any = $localize`:@@general.breadcrumb.clubSettings:Club Settings`;
  public i18nClubAttributes: any = $localize`:@@general.breadcrumb.clubAttributes:Club Attributes`;
  public i18nClubUsers: any = $localize`:@@general.breadcrumb.clubUsers:Club Users`;
  public i18nCustomerSearch: any = $localize`:@@general.breadcrumb.customerSearch:Customer Search`;
  public i18nCustomerProfile: any = $localize`:@@general.breadcrumb.customerProfile:Customer Profile`;
  public i18nLastContacts: any = $localize`:@@general.breadcrumb.lastContacts:Last Contacts`;
  public i18nMerchandising: any = $localize`:@@general.breadcrumb.merchandising:Merchandising`;
  public i18nTicketing: any = $localize`:@@general.breadcrumb.ticketing:Ticketing`;
  public i18nCampaignActivity: any = $localize`:@@general.breadcrumb.campaignActivity:Campaign Activity`;
  public i18nUserProfile: any = $localize`:@@general.breadcrumb.userProfile:User Profile`;
  public i18nImports: any = $localize`:@@general.breadcrumb.imports:Imports`;
  public i18nReminders: any = $localize`:@@general.breadcrumb.reminders:Reminders`;
  public i18nTixxSelect: any = $localize`:@@general.breadcrumb.tixxSelect:Tixx-Select`;
  public i18nCustomerMerger: any = $localize`:@@general.breadcrumb.customerMerger:Customer Merger`;
  public i18nTixxFanPortal: any = $localize`:@@general.breadcrumb.tixxFanPortal:Tixx-FanPortal`;

  constructor() { }
}
